import StudentData from "../components/StudentData";
import Loading from "../components/Loading";
import { useState } from "react";
import { FiSearch } from "react-icons/fi";

export default function StudentList({
  setSearch,
  search,
  students,
  loading,
  count,
}) {
  const user = JSON.parse(localStorage.getItem("profile")).value[0];
  const [localSearch, setLocalSearch] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(localSearch);
    setHasSearched(true);
  };

  return (
    <div className="flex flex-col">
      {/* Count badge (non-user roles) */}
      {count && (
        <div className="mb-4 flex items-center gap-2">
          <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-indigo-600/20 border border-indigo-500/30 text-indigo-300 text-sm font-bold">
            {students?.length}
          </span>
          <span className="text-slate-400 text-sm">students in this state</span>
        </div>
      )}

      {/* Search form */}
      <form className="flex gap-2 mb-6" onSubmit={handleSearch}>
        <input
          type="search"
          className="flex-1 bg-slate-800/60 border border-slate-600 text-white placeholder-slate-400 h-10 px-4 rounded-lg text-sm focus:outline-none focus:border-indigo-400 focus:ring-1 focus:ring-indigo-400"
          placeholder="Search by name, ID or Passport No.…"
          onChange={(e) => setLocalSearch(e.target.value)}
          value={localSearch}
        />
        <button
          type="submit"
          className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-500 text-white px-5 py-2 rounded-lg text-sm font-medium transition-colors"
        >
          <FiSearch size={14} /> Search
        </button>
      </form>

      {/* Results */}
      {hasSearched ? (
        loading ? <Loading /> : <StudentData students={students} />
      ) : (
        <p className="text-slate-500 text-sm text-center py-8">
          Press Search to load students — leave blank to show all in this state.
        </p>
      )}
    </div>
  );
}

